export default __webpack_public_path__ + "static/media/bg-fallback.ca8da11d.png";